// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SharedAddressAccountDataModel {
    static getAttributeTypeMap() {
        return SharedAddressAccountDataModel.attributeTypeMap;
    }
}
SharedAddressAccountDataModel.discriminator = undefined;
SharedAddressAccountDataModel.additionalProperties = false;
SharedAddressAccountDataModel.attributeTypeMap = [
    {
        "name": "receiverFirstName",
        "baseName": "receiverFirstName",
        "type": "string"
    },
    {
        "name": "receiverLastName",
        "baseName": "receiverLastName",
        "type": "string"
    },
    {
        "name": "addressType",
        "baseName": "addressType",
        "type": "AddressType"
    },
    {
        "name": "addressOne",
        "baseName": "addressOne",
        "type": "string"
    },
    {
        "name": "addressTwo",
        "baseName": "addressTwo",
        "type": "string"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "zip",
        "baseName": "zip",
        "type": "string"
    },
    {
        "name": "country",
        "baseName": "country",
        "type": "string"
    },
];
//# sourceMappingURL=sharedAddressAccountDataModel.js.map